export enum FilterViewTypes {
  DateRange,
  MultiSelect,
  MultiSelectWithAddition,
  MultiSelectWithWindow,
  Select,
  Checkbox,
}
